export const SN_COOKIES = 'cookies'
export const COOKIES_SET_COOKIE_CONSENT = SN_COOKIES + '/SET_COOKIE_CONSENT'
